@if (loaded$ | async) {
  <ng-content></ng-content>
} @else {
  <div class="button-spinner-container">
    <mat-spinner
      [ngClass]="usePrimaryColor ? 'button-spinner-primary' : 'button-spinner-white'"
      [diameter]="30"
    ></mat-spinner>
  </div>
}
